// ============================================
// Anonymous Session ID
// Generates a persistent UUID for anonymous users.
// Used as userId in consent records and audit log
// until real Firebase Auth is linked at order time.
// ============================================

const STORAGE_KEY = 'hemologix_session_id';

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/** Get or create a persistent anonymous session ID */
export function getSessionId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;

    const id = `anon_${generateUUID()}`;
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // localStorage blocked (incognito, etc.) — use ephemeral ID
    return `ephemeral_${generateUUID()}`;
  }
}

/** Override the stored session ID (used when resuming a UID-based journey). */
export function setSessionId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // localStorage unavailable — no-op
  }
}
